import React, { useState } from "react";
import styles from "./ForgotPassword.module.css";
import { forgotPassword } from "../../services/AuthServices";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import globalStyles from "../../styles/globalStyles.module.css";
import loginStyles from "../Login/Login.module.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState<string>();
  const { t } = useTranslation();
  const [message, setMessage] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleForgotPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || loading) return;

    setLoading(true);
    setMessage(""); // Optional: clear previous messages

    try {
      const success = await forgotPassword(email);
      if (success) {
        setIsSent(true);
        setMessage(t("forgotPasswordSuccess"));
      } else {
        setMessage(t("forgotPasswordFail")); // Optional error handling
      }
    } catch (error) {
      setMessage(t("forgotPasswordError")); // Optional: translate error
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={loginStyles.mainContainer}>
      <div className={loginStyles.leftPanelContainer}>
        <div className={loginStyles.header}>
          <img
            className={loginStyles.logo}
            src="/images/logo/company.svg"
            alt="logo"
          />
          <h1>{t("forgotPasswordTitle")}</h1>
        </div>
      </div>
      <div className={loginStyles.container}>
        <div className={loginStyles.loginFormContainer}>
          <div>
            <h1 className={styles.heading}>{t("forgotPasswordSubtitle")}</h1>
            <div>{t("forgotPasswordDescription")}</div>
            <form onSubmit={handleForgotPassword}>
              <div className={`form-group ${styles.formGroup}`}>
                <label>{t("email")}</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={styles.inputBox}
                  placeholder={t("email")}
                  required
                />
              </div>
              {!isSent ? (
                <button
                  type="submit"
                  className={styles.button}
                  disabled={loading}
                >
                  {loading ? t("sending") : t("sendEmail")}
                </button>
              ) : (
                <Link to="/" className={globalStyles.unset}>
                  <button className={styles.button}>return to login</button>
                </Link>
              )}
            </form>
            <div>{message}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
